import { render } from "./ProfileComponent.vue?vue&type=template&id=6ed32a2d"
import script from "./ProfileComponent.vue?vue&type=script&lang=js"
export * from "./ProfileComponent.vue?vue&type=script&lang=js"

import "./ProfileComponent.vue?vue&type=style&index=0&id=6ed32a2d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__